import _Modules from '../core/core--modules';
import scrollpoints from './module--scrollpoints-promise';
import anchorsScroll from './module--anchorsScroll';
import collapsibles from './module--collapsible';

export default new _Modules({
    name: 'Module: Menu Aside (Topcs, Collapsibles)',
    settings: {
        scrollpointElement: '.scrollpoint--menu-aside',
        menuWrapElement: '.menu-aside',
        collapsibleBlock: '.collapsible-aside',
        collapsibleToggle: '.collapsible-aside__toggle',
        collapsibleContent: '.collapsible-aside__content',
        collapsibleToggleRemote: '.menu-topics__toggle',
        classMenuList: 'menu-topics__list',
        classMenuItem: 'menu-topics__item',
        classMenuLink: 'menu-topics__link',
        classSlowScroll: 'slow-scroll--aside',
        statusClassActive: 'active',
        statusClassInactive: 'inactive',
        onMenuReadyL1: null,
        onMenuReadyL2: null
    },
    fn() {
        const _module = this;
        // Note: If using _module.settings, you get value from just one instance
        const { settings, name } = _module;
        const {
            scrollpointElement,
            menuWrapElement,
            collapsibleBlock,
            collapsibleToggle,
            collapsibleContent,
            collapsibleToggleRemote,
            classMenuList,
            classMenuItem,
            classMenuLink,
            classSlowScroll,
            statusClassActive,
            statusClassInactive,
            onMenuReadyL1,
            onMenuReadyL2
        } = settings;

        const $scrollpointElement = $(scrollpointElement);
        const $menuWrapElement = $(menuWrapElement);
        const $collapsibleBlock = $(collapsibleBlock);

        function isFunction(functionToCheck) {
            return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
        }

        function setupSpMenu(sp) {
            return sp
                .add({
                    scrollpoint: scrollpointElement,
                    offset: 0,
                    elementOffset: 'brand', // by ID for now
                    direction: 'both',
                    menu: true,
                    menuTitle: '.topic__title',
                    debug: false
                })
                .get()
                .then(spArr => {
                    initialSetup();
                    addMenuItems(spArr);
                    addSlowScroll('1');
                    toggleMenuItemsState(scrollpoints);
                    return new Promise(function(resolve, reject) {
                        resolve({ settings, spArr });
                    });
                })
                // Callback
                .then(params => {
                    if (isFunction(onMenuReadyL1)) onMenuReadyL1(params);
                    return menuReadyLevel1(params);
                })
                .then(params => {
                    return setupCollapsibles();
                })
                .then(collapsibleInstance => {
                    addMenuItemsL2(collapsibleInstance);
                    addSlowScroll('2');
                    return new Promise(function(resolve, reject) {
                        resolve({ settings, collapsibleInstance });
                    });
                })
                .catch(e => {
                    console.error(e);
                })
                // Callback
                .then(params => {
                    if (isFunction(onMenuReadyL2)) onMenuReadyL2(params);
                    return menuReadyLevel2(params);
                })
                .catch(e => {
                    console.error(e);
                })
                .finally(function() {});
        }
        
        function initialSetup() {
            const existingItems = $menuWrapElement.find(`ul.${classMenuList}.${classMenuList}--l1`);
            if (existingItems.length > 0) existingItems.remove();
            $menuWrapElement.append(`<ul class="${classMenuList} ${classMenuList}--l1"></ul>`);
        }

        function addMenuItems(spArr) {
            spArr.forEach(function({ name, id, isActive }, i) {
                if (id) {
                    $(`.${classMenuList}`).append(
                      `<li class='${classMenuItem} ${classMenuItem}--l1'>
                          <a class='${classMenuLink} ${classMenuLink}--l1 slow-scroll--aside' href='#${id}'>
                              ${name}
                          </a>
                      </li>`
                    );
                }
            });
        }

        function toggleMenuItemsState(sp) {
            $(window).on('on:Scroll', function() {
                const result = sp
                    .add({
                        scrollpoint: scrollpointElement,
                        offset: 0,
                        elementOffset: 'brand', // by ID for now
                        direction: 'both',
                        menu: true,
                        menuTitle: '.topic__title',
                        debug: false
                    })
                    .get();
                result.then(spArr => {
                    const $menuItems = $(`.${classMenuItem}--l1`);
                    spArr.forEach(function({ name, id, isActive }, i) {
                        $($menuItems.get(i))
                            .addClass(isActive ? statusClassActive : statusClassInactive)
                            .removeClass(isActive ? statusClassInactive : statusClassActive);
                    });
                });
            });
        }

        function setupCollapsibles() {
            let moduleBuilt;
            const moduleInstance = collapsibles.add({
                block: collapsibleBlock,
                elToggle: collapsibleToggle,
                elContent: collapsibleContent,
                elToggleRemote: collapsibleToggleRemote,
                fireAs: 'async',
                closeOutside: false,
                closeAny: false,
                closeOthers: true,
                speed: 300,
                debug: false,
                callbackBuilt({ elToggle, elToggleRemote }) {
                    return function cb() {
                        moduleBuilt = true;
                    };
                },
                callbackOpenAfter({ elToggleRemote }, { $activeToggle }) {
                    const $currentRemoteToggle = $(`[data-collapsible-remote-target=${$activeToggle.attr('id')}]`);
                    $currentRemoteToggle
                        .attr({ 'data-cc-state': $activeToggle.attr('data-cc-state') })
                        .next()
                        .triggerHandler('click');
                },
                callbackCloseAfter({ elToggleRemote }, { $activeToggle }) {
                    $(elToggleRemote).attr({ 'data-cc-state': 'closed' });
                }
            });
            return new Promise(function(resolve, reject) {
                if (moduleBuilt) {
                    resolve(moduleInstance);
                } else {
                    const why = 'Collapsibles build didn not happen. Check!';
                    reject(why);
                }
            });
        }

        function addMenuItemsL2(collapsibleInstance) {
            const { getSettings } = collapsibleInstance;
            const settingsCollapsibles = getSettings();
            const { elToggle, elToggleRemote } = settingsCollapsibles;

            // Add ULs
            $scrollpointElement.each(function(i, topicItem) {
                const $topicItem = $(topicItem);
                // Make Menu
                // 1. Find Remote Button
                const $remoteButton = $(`a[href*=${$topicItem.attr('id')}]`);
                const $remoteLiItem = $remoteButton.parent('li');
                // 2. Insert Container
                $remoteLiItem.append(
                    $(`<ul class="${classMenuList} ${classMenuList}--l2" data-source-topic-id="${$topicItem.attr('id')}"></ul>`)
                );
            });

            const $menuListL2 = $(`.${classMenuList}--l2`);

            // Add Links
            $(elToggle).each(function(i, el) {
                const $elToggle = $(el);
                const title = $elToggle.attr('data-collapsible-remote-title');
                const initialState = $elToggle.attr('data-cc-state');
                const id = $elToggle.attr('id');

                const listItem = $(
                    `<li class='${classMenuItem} ${classMenuItem}--l2'><button class="${elToggleRemote.substring(
                        1
                    )}" type="button" data-cc-state="${initialState}" data-collapsible-remote-target="${id}">${title}</button></li>`
                );

                $menuListL2.each(function(j, ele) {
                    const $ele = $(ele);
                    const idMenu = $ele.attr('data-source-topic-id');
                    const idContent = $elToggle.closest(scrollpointElement).attr('id');
                    if (idMenu === idContent) $ele.append(listItem);
                });

                const link = $(
                    `<a href="#${id}" tabindex="-1" class="${classMenuLink} ${classMenuLink}--l2 slow-scroll--aside hide-v">${title}</a>`
                );
                listItem.append(link);
            });

            $(elToggleRemote).on('click', function(e) {
                const $remoteToggle = $(this);
                const $currentToggle = $(`#${$remoteToggle.attr('data-collapsible-remote-target')}`);
                $currentToggle.trigger('click');
            });
        }

        function addSlowScroll(level) {
            anchorsScroll.add({
                selector: `.${classMenuLink}--l${level}.${classSlowScroll}`,
                fireAs: 'async',
                offset: 48 * 2, // Header height
                breakpoint: 'laptop',
                breakpointDir: 'up'
            });
        }

        function menuReadyLevel1(currentParams) {
            return new Promise(function(resolve, reject) {
                resolve(currentParams);
            });
        }

        function menuReadyLevel2(currentParams) {
            return new Promise(function(resolve, reject) {
                resolve(currentParams);
            });
        }

        // Fire
        if ($menuWrapElement.length) {
            setupSpMenu(scrollpoints);
        }
        return _module;
    }
});
